<template>
  <div class="did-container">
    <nav class="add-navigation d-flex flex-column flex-sm-row justify-content-sm-between">
      <div
        @click="$router.push({ name: 'system-admin-dids-all-dids' })"
        class="back-link mb-3 mb-sm-0"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p>Back to DIDs</p>
      </div>
      <div class="buttons-wrapper">
        <div
          @click="$router.push({ name: 'system-admin-dids-all-dids' })"
          class="secondary-button"
        >
          <secondary-button>Cancel</secondary-button>
        </div>
        <div class="primary-button">
          <primary-button @click.native="importDid">Import DID</primary-button>
        </div>
      </div>
    </nav>
    <div class="add-container p-3">
      <span class="container-title d-block p-0 mb-4">Import DID</span>
      <div class="row">
        <div class="col-md-6 col-12">
          <primary-select
            type="text"
            name="method"
            class="type"
            v-validate="'required'"
            :class="{ input: true, 'is-danger': errors.has('method') }"
            v-model="did.method"
            placeholder="Select Method"
            :options="methods"
          />
          <div class="help is-danger" v-if="errors.has('method')">
            {{ errors.first("method") }}
          </div>
          <primary-select
            type="text"
            name="error"
            class="type input"
            v-validate="'required'"
            v-model="did.error"
            placeholder="Select Action"
            :class="{ input: true, 'is-danger': errors.has('error') }"
          >
            <option :value="i" v-for="(i, k) in error_list" :key="k">
              {{ i }}
            </option>
          </primary-select>
          <div class="help is-danger" v-if="errors.has('error')">
            {{ errors.first("error") }}
          </div>
          <primary-select
            type="text"
            name="duplicate action"
            class="type input"
            v-validate="'required'"
            v-model="did.duplicates_action"
            placeholder="Select Action"
            :class="{ input: true, 'is-danger': errors.has('duplicate action') }"
          >
            <option :value="i" v-for="(i, k) in duplicates_actions" :key="k">
              {{ i }}
            </option>
          </primary-select>
          <div class="help is-danger" v-if="errors.has('duplicate action')">
            {{ errors.first("duplicate action") }}
          </div>
          <primary-select
            type="text"
            name="company"
            class="type input"
            v-model="did.company_uuid"
            placeholder="Select Company"
            :options="companies"
          />
          <primary-select
            type="text"
            name="vendor"
            class="type input"
            v-model="did.vendor_uuid"
            placeholder="Select Vendor"
            :options="vendors"
          />
          <primary-select
            type="text"
            name="user"
            class="type input"
            v-model="did.user_uuid"
            :options="users"
            placeholder="Select User"
          />
          <primary-select
            type="text"
            name="ani group"
            class="type input"
            v-model="did.ani_group_uuid"
            placeholder="Select ANI GROUP"
            :options="ani_group_list"
          />
        </div>
        <div class="col-md-6 col-12">
          <div class="upload-container">
            <p class="pimary-input-title">Add Attachment</p>
            <app-dropzone
              @fileAdd="fileAdded($event)"
              @remove="fileRemoved($event)"
              :optionsProp="dropzoneOptions"
              class="upload-photo"
            ></app-dropzone>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { mapActions } from "vuex";

export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    AppDropzone: () => import("@/components/Dropzone"),
    DatePicker: () => import("vuejs-datepicker"),
  },
  data: () => ({
    didError: null,
    did: {
      method: "",
      error: "",
      file: null,
      ani_group_uuid: null,
      duplicates_action: "",
      user_uuid: null,
      company_uuid: null,
      vendor_uuid: null,
    },
    methods: [
      { name: "ANI", value: "ani" },
      { name: "DNIS", value: "dnis" },
      { name: "remove_from_group", value: "remove_from_group" },
      { name: "remove", value: "remove" },
    ],
    dropzoneOptions: {
      acceptedFiles: ".csv"
    },
    duplicates_actions: ["skip", "overwrite"],
    error_list: ["skip", "abort"],
    companies: [],
    vendors: [],
    ani_group_list: [],
    users: [],
    fileId: null,
    file: null,
    enabledUpload: true,
  }),
  created() {
    this.GetUserList();
    this.GetAniGroupList();
    this.getCompaniesList();
    this.getVendors();
  },
  methods: {
    ...mapActions({
      getVendorsList: "GetVendorList",
    }),
    async getVendors() {
      const { total } = await this.getVendorsList({ page: 0, per_page: 1 });
      const res = await this.getVendorsList({ page: 0, per_page: total });
      this.vendors = [
        ...res.items.map(this.transformVendor),
      ];
    },
    async GetUserList() {
      this.$store
        .dispatch("GetUsersListing", { page: 0, per_page: 1 })
        .then((res) => {
          const { total } = res;

          this.$store
            .dispatch("GetUsersListing", { page: 0, per_page: total })
            .then((res) => {
              this.users = [
                ...res.items.map(this.transformUser),
              ];
            });
        });
    },
    GetAniGroupList() {
      this.$store.dispatch("GetAniList", { per_page: 1 }).then((res) => {
        const { total } = res;

        this.$store.dispatch("GetAniList", { per_page: total }).then((res) => {
          this.ani_group_list = [
            ...res.items.map(this.transformAniGroup),
          ];
        });
      });
    },
    async getCompaniesList() {
      const { total } = await this.$store.dispatch("GetCompanyList", {});
      const { items } = await this.$store.dispatch("GetCompanyList", {
        perPage: total,
      });
      this.companies = [
        ...items.map(this.transformCompany),
      ];
    },
    fileAdded(file) {
      if (file.accepted) {
        this.file = file;
        this.enabledUpload = false;
      }
    },
    fileRemoved() {
      this.file = null;
      this.did.file = null;
    },
    uploadPhoto: async function () {
      let data = new FormData();

      data.append("file", this.file);
      // data.append("type", 'application/vnd.ms-excel');

      return await this.$store.dispatch("UploadFile", data);
    },
    importDid: async function () {
      const valid = await this.$validator.validate();

      if (valid) {
        if (!this.file) {
          this.$snotify.error("File didn't select", { timeout: 6000 });
          return;
        }

        let data = new FormData();

        data.append("file", this.file);
        data.append("on_duplicate", this.did.duplicates_action);
        data.append("on_error", this.did.error);
        data.append("command", this.did.method);
        
        if (this.did.vendor_uuid) data.append("vendor_uuid", this.did.vendor_uuid);
        if (this.did.user_uuid) data.append("user_uuid", this.did.user_uuid);
        if (this.did.company_uuid) data.append("company_uuid", this.did.company_uuid);
        if (this.did.ani_group_uuid) data.append("ani_group_uuid", this.did.ani_group_uuid);

        this.$store.dispatch("ImportDidKannel", data)
        .then((res) => {
          this.$snotify.success("DID has been imported.", {
            timeout: 6000,
          });

          this.$router.push({ name: "system-admin-dids-import-log" });
        })
        .catch((err) => {
          console.log(err)
            this.$snotify.error(err.errors[0], { timeout: 6000 });
        });
      }
    },
    transformAniGroup(item) {
      return {
        name: item.ani_group_name,
        value: item.ani_group_uuid,
      };
    },
    transformVendor(item) {
      return {
        name: item.vendor_name,
        value: item.vendor_uuid,
      };
    },
    transformCompany(item) {
      return {
        name: item.company_name,
        value: item.company_uuid,
      };
    },
    transformUser(item) {
      return {
        name: item.user_name,
        value: item.user_id,
      };
    },
  },
};
</script>

<style lang="scss">
.did-container {
  font-family: "Helvetica Neue";
  .add-navigation {
    width: 100%;
    margin-top: 20px;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 130px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    height: fit-content;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;

    .container-title {
      height: 30px;
      color: #000000;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
      padding: 15px 0 15px 0;
    }

    .row .primary-input-container {
      margin-bottom: 20px;
    }
  }
  .primary-input-container {
    width: 100%;
    .pimary-input-title {
      color: #000000;
      font-family: "Helvetica Neue";
      font-size: 12px;
      font-weight: 900;
      letter-spacing: 0.21px;
      line-height: 15px;
      margin-bottom: 5px;
      text-transform: uppercase;
    }
    .primary-select-wrapper {
      box-sizing: border-box;
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      border: 1px solid #edeef3;
      border-radius: 4px;
      background-color: #ffffff;

      ::placeholder {
        color: #55616e !important;
        opacity: 1;
      }
      .calendar-class {
        width: fit-content !important;
        height: fit-content !important;
        font-family: "Helvetica Neue";
        font-size: 14px;
      }
      .date-wrapper {
        width: 100%;
      }
      .vdp-datepicker {
        div {
          width: 100%;
        }
      }
      .date-picker {
        width: 100%;
        min-height: 40px;
        display: block;
        background: transparent;
        padding-left: 15px;
        font-family: "Helvetica Neue";
        font-size: 14px;
        line-height: 25px;
        border: none;
      }
      select:focus {
        border: 1px solid #51a3f3;
      }
      .icon-down {
        position: absolute;
        left: 100%;
        margin-left: -35px;
      }
    }
  }
}
  .help {
    position: absolute;
    margin-top: -20px;
  }
</style>
